import React from 'react';
import ModuleLayout from '../../layouts/ModuleLayout';
import QRCodeManagement from '../../components/QRMenu/QRCodeManagement';

import { useAuth } from "@/context/AuthContext";
import { P } from "@/config/permissionCodes";

export default function QRCodesPage() {

  const { hasPermission } = useAuth();

  const canViewQRCodes = hasPermission(P.QR_MENU.QR_CODES.SCREEN);

  if (!canViewQRCodes) {
    return (
      <ModuleLayout>
        <div className="flex items-center justify-center h-full py-24">
          <div className="text-center">

            <h3 className="text-lg font-semibold text-slate-900 mb-2">
              Access Denied
            </h3>

            <p className="text-sm text-slate-500">
              You don't have permission to view this page.
            </p>

          </div>
        </div>
      </ModuleLayout>
    );
  }

  return (
    <ModuleLayout>
      <QRCodeManagement />
    </ModuleLayout>
  );
}